import { useEffect, useState } from 'react';

const navItems = [
  { label: '版本速览', href: '#versions' },
  { label: '使用体验', href: '#experience' },
  { label: '安装指引', href: '#install' },
  { label: '常见问题', href: '#faq' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 xl:px-14 h-16 md:h-[68px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-compasses-2-fill text-xl"></i>
          </span>
          <span className="font-heading font-bold text-lg text-foreground-950 tracking-tight">
            91浏览器
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#versions"
            className="hidden sm:inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-download-2-line text-base"></i>
            下载安卓版
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 rounded-md border border-background-300 flex items-center justify-center text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pb-5 pt-2">
          <div className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-sm text-foreground-700 border-b border-background-200 last:border-0 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#versions"
              onClick={() => setMenuOpen(false)}
              className="mt-4 inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 text-sm font-medium px-4 py-3 rounded-md cursor-pointer"
            >
              <i className="ri-download-2-line text-base"></i>
              下载安卓版
            </a>
          </div>
        </div>
      )}
    </header>
  );
}